'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDataByPath = getDataByPath;
function getDataByPath(object, path) {
    if (!object || !path) {
        return false;
    }
    path = path.toString();
    var field = path.split('.'),
        val = void 0,
        key = void 0;
    if (field.length) {
        key = field[0];
        //lists[1].name
        if (key.indexOf('[') >= 0) {
            key = key.match(/(.*)\[(.*)\]/);
            if (key) {
                val = object[key[1]][key[2]];
            }
        } else {
            val = object[field[0]];
        }
        if (val) {
            for (var i = 1; i < field.length; i++) {
                val = val[field[i]];
                if (typeof val === 'undefined') {
                    break;
                }
            }
        }
    }
    return val;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-detail@0.0.6@@alicd/crui-detail/lib/util.js
// module id = 630
// module chunks = 0